import React, {useEffect, useState} from 'react';
import {
  format,
  startOfYesterday,
  addDays,
  endOfDay,
  startOfDay
} from 'date-fns';
import {getTodayLogUpdates, getTodayLogTime} from '../../services/daily';

interface ShowDailyLogTimeRef {
  userId?: string;
  isAdmin: boolean;
  createdAt?: number;
}

const ShowDailyLogTime: React.FC<ShowDailyLogTimeRef> = ({
  userId,
  isAdmin,
  createdAt = 0
}: ShowDailyLogTimeRef) => {
  console.log(isAdmin, 'isAmdmin11111111111111111111111111111111111111');
  const [todayLogs, setTodayLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const formatTimeInHoursAndMinutes = (totalMinutes: number) => {
    if (Number.isNaN(totalMinutes) || totalMinutes < 0) {
      return 'N/A';
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
      return `${hours}h${minutes}m`;
    }

    if (hours > 0) {
      return `${hours}h`;
    }

    if (minutes > 0) {
      return `${minutes}m`;
    }
    return 'N/A';
  };

  const parseHoursAndMinutes = (time: string) =>
    time
      .split(/[hHmM]/)
      .filter(Boolean)
      .map(Number);

  const calculateTime = (time: any[]) => {
    let totalTime = 0;
    time.forEach((task) => {
      const [hours = 0, minutes = 0] = parseHoursAndMinutes(task.time);

      totalTime += hours * 60 + minutes;
    });

    return formatTimeInHoursAndMinutes(totalTime);
  };

  function getStartAndEndOfDay(timestamp: number) {
    const date = new Date(timestamp);
    const start = startOfDay(date);
    const end = endOfDay(date);

    return {
      startOfDay: start.getTime(), // Convert back to timestamp
      endOfDay: end.getTime() // Convert back to timestamp
    };
  }

  const getTodayLoggedTime = async () => {
    setLoading(true);

    let resp = null;

    if (isAdmin) {
      const {startOfDay, endOfDay} = getStartAndEndOfDay(createdAt);

      resp = await getTodayLogTime(startOfDay, endOfDay, userId);
    } else {
      resp = await getTodayLogUpdates();
    }

    setTodayLogs(resp.data.data);
    setLoading(false);
  };

  useEffect(() => {
    getTodayLoggedTime();
  }, []);

  return (
    <div>
      <table className="table table-hover text-nowrap">
        <thead>
          <tr>
            <th>Task ID</th>
            <th>Title</th>
            <th>Time Spent</th>
            <th>Link</th>
          </tr>
        </thead>
        <tbody>
          {todayLogs.map((log, index) => {
            return (
              <tr>
                <td>{log.taskNo}</td>
                <td>{log.title.substring(0, 65)}</td>
                <td>{calculateTime(log.timeSpent)}</td>
                <td>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`/tasks/${log.projectId}/${log.taskNo}`}
                  >
                    Open
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ShowDailyLogTime;
